// import APIs
import { getDutyLines } from 'RestAPIs/employees/hours-table';

// import external libraries
import { useQuery } from 'react-query';

// import types
import { GetDutyLinesProps } from 'RestAPIs/employees/hours-table/types';

const useGetDutyLines = (
  { employeeId, startDate, endDate, showUnpublished }: GetDutyLinesProps,
  options: Record<string, any> = {}
) => {
  const { data, isFetching, isError, refetch } = useQuery(
    ['hoursTable', employeeId, startDate, endDate],
    async () => {
      const { data } = await getDutyLines({
        employeeId,
        startDate,
        endDate,
        showUnpublished
      });
      return data;
    },
    options
  );
  return { data, isFetching, isError, refetch };
};

export default useGetDutyLines;
